import React, { Fragment } from 'react';

import numeral from 'numeral';
import moment from 'moment';

import {
  Box,
  makeStyles,
  TableCell,
  TableRow,
  Tooltip,
  colors,
  Avatar,
  IconButton,
  Icon,
  Grid,
  Link,
  Typography,
  Chip
} from '@material-ui/core';

import { green, red, yellow } from '@material-ui/core/colors';

import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import BuildIcon from '@material-ui/icons/Build';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import { FaFile } from "react-icons/fa";
import { BsPlayCircleFill } from "react-icons/bs";
import ErrorIcon from '@material-ui/icons/Error';

const useStyles = makeStyles((theme) => ({
  root: {
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.grey[200]
  },
  sit0: {
    color: colors.red[600],
    fontSize: '1.1em',
    fontWeight: 'bold'
  },
  sit1: {
    color: colors.yellow[800],
    fontSize: '1.1em',
    fontWeight: 'bold'
  },
  sit2: {
    color: colors.green[600],
    fontSize: '1.1em',
    fontWeight: 'bold'
  }
}));

const formatDecimal = (value) => {
  return numeral(value).format('0.00').replace('.', ',');
}

const formatNumber = (value, mask) => {
  return numeral(value).format(mask);
}

const formatDate = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY')
  } else {
    return ""
  }
}

const formatDatetime = (value) => {
  if (value) {
    return moment(value).format('DD/MM/YYYY HH:mm:ss')
  } else {
    return ""
  }
}

const fileSize = (bytes) => {
  var exp = Math.log(bytes) / Math.log(1024) | 0;
  var result = (bytes / Math.pow(1024, exp)).toFixed(2);
  return result + ' ' + (exp == 0 ? 'bytes' : 'KMGTPEZY'[exp - 1] + 'B');
}


const truncateValue = (value, size) => {
  if (value.length > size) {
    return value.substring(size - 3, 0) + '...';
  } else {
    return value;
  }
}
const getIconColor = (item) => {
  return { color: colors.cyan[400] }
}

const getTypeStyle = (item) => {
  return { color: 'white', backgroundColor: 'gray' }
}


const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const Register = ({ icon, item, resultMode, openEdition, procerrors }) => {

  const classes = useStyles();

  const getFieldValue = (column) => {
    try {
      var value = eval(column.field);
      return ((value) ? value : "");
    } catch (error) {
      return "";
    }
  }

  const getBackgroundColor = (col, item) => {
    var style = {};
    if (col.name == 'Agência') {
      style = (!item.unidade) ? { backgroundColor: yellow[500] } : {}
    } else if (col.name == 'Categoria') {
      style = (!item.categoria) ? { backgroundColor: yellow[500] } : {}
    } else if (col.name == 'Sintoma') {
      style = (!item.sintoma) ? { backgroundColor: yellow[500] } : {}
    } else if (col.name == 'Local do Sintoma') {
      style = (!item.localSintoma) ? { backgroundColor: yellow[500] } : {}
    }
    return style;
  }

  const getColor = (item, error) => {
    if (error) {
      return { color: red[700] }
    } else {
      return { color: green[700] }
    }
  }

  const isError = (numero, errors) => {
    for (let index = 0; index < errors.length; index++) {
      const element = errors[index];
      if (element.id == numero) {
        return true;
      }
    }
    return false;
  }

  const getError = (numero, errors) => {
    for (let index = 0; index < errors.length; index++) {
      const element = errors[index];
      if (element.id == numero) {
        return element.error;
      }
    }
    return "Erro no processo.";
  }

  return (
    <Fragment>

      <TableRow hover key={item.name} className={classes.root}>

        {resultMode.columns.map((col, index) => (
          (index == 0) ? (

            <TableCell>
              <Box
                noWrap={(col.wrap)}
                alignItems="center"
                display="flex"
                component={Link}
                onClick={() => { (resultMode.update == LEVEL_ACCESS_ENABLED) ? openEdition(item) : {} }}
              >
                <Avatar
                  className={classes.avatar}
                >

                  {isError(item.numero, procerrors) ?
                    <Tooltip title={getError(item.numero, procerrors)} >
                      <Icon component={ErrorIcon} style={getColor(item, true)} ></Icon>
                    </Tooltip>
                    :
                    <Icon component={icon} style={getColor(item, false)} ></Icon>
                  }
                </Avatar>
                {getFieldValue(col)}
              </Box>
            </TableCell>

          ) : (

            <TableCell style={getBackgroundColor(col, item)} >

              <Typography variant="body" noWrap={(col.wrap)}  >
                {getFieldValue(col)}
              </Typography>

            </TableCell>
          )))}

      </TableRow>

    </Fragment >
  );
}

export default Register;